import * as types from '../actions/types'
import Immutable from 'immutable'

import { tableCols, findValues } from '../containers/Parametros'
import { isPrimitive, parametro, parametroConfig } from '../utils/helpers'

const INITIAL_STATE = Immutable.fromJS({
	
	parametros: [],
	orderBy: {
		field: null,
		asc: false
	},

	modalCreate: {
		title: '',
		mode: '',
		show: false,
		data: null,
		btnDisabled: false
	},
	modalDelete: {
		show: false,
		action: null,
		message: null
	},
})

export default function (state = INITIAL_STATE, action) {
	let id
	let data
	let index
	switch (action.type) {
		case types.OBTENER_ADMIN_PARAMETROS:
			state = state.set('parametros', Immutable.fromJS(action.payload))
			return state
		case types.CONMUTAR_SELECCION_ADMIN_PARAMETRO:
			state = state.setIn(['parametros', action.payload.index, 'selected'], action.payload.checked)
			return state
		case types.CONMUTAR_SELECCION_TODOS_ADMIN_PARAMETROS:
			state.get('parametros').forEach((x, n) => {
				if (action.payload) {
					if (x.get('visible')) {
						state = state.setIn(['parametros', n, 'selected'], action.payload)
					}
				} else {
					state = state.setIn(['parametros', n, 'selected'], action.payload)
				}
			})
			return state
		case types.FILTRAR_ADMIN_PARAMETROS:
			const term = action.payload.toLowerCase()
			const pattern = new RegExp(term.replace(/\*/g, '.*'))
			const searchCols = tableCols
			if (term) {
				data = state.get('parametros').map(x => {
					let compare = false
					searchCols.forEach(c => {
						let value = findValues(c, x).toString()
						compare = compare || pattern.test(value.toLowerCase())
					})
					x = x.set('visible', compare)
					return x
				})
				state = state.set('parametros', data)
				data = null
			} else {
				state = state.set('parametros', state.get('parametros').map(x => { x = x.set('visible', true); return x }))
			}
			return state
		case types.ORDENAR_ADMIN_PARAMETROS:
			state = state.set('orderBy', action.payload.orderBy)
			let c = state.getIn(['orderBy', 'field'])
			if (c) {
				data = state.get('parametros').sort((a, b) => {
					let va = findValues({ Value: c }, a).toString()
					let vb = findValues({ Value: c }, b).toString()
					va = va || ''
					vb = vb || ''
					return va > vb ? 1 : (va === vb ? 0 : -1 )
				})
				if (!state.getIn(['orderBy', 'asc'])) data = data.reverse()
				state = state.set('parametros', data)
			}
			return state
		case types.MOSTRAR_MODAL_CREAR_ADMIN_PARAMETRO:
			state = state.setIn(['modalCreate', 'show'], action.payload.show)
			state = state.setIn(['modalCreate', 'title'], action.payload.title)
			state = state.setIn(['modalCreate', 'mode'], action.payload.mode)
			if (action.payload.mode === 'create') {
				state = state.setIn(['modalCreate', 'data'], Immutable.fromJS(parametro()))
			} else if (action.payload.mode === 'edit') {
				index = state.get('parametros').findIndex(x => x.get('id') === action.payload.id)
				state = state.setIn(['modalCreate', 'data'], state.getIn(['parametros', index]))
			}
			return state
		case types.MODIFICAR_INPUTS_MODAL_CREATE_ADMIN_PARAMETROS:
            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }
            return state
		case types.CREAR_ACTUALIZAR_ADMIN_PARAMETRO:
			id = action.payload.id
			index = state.get('parametros').findIndex(x => x.get('id') === id)
			if (index !== -1) {
				state = state.setIn(['parametros', index], Immutable.fromJS(action.payload))
			} else {
				state = state.set('parametros', state.get('parametros').push(Immutable.fromJS(action.payload)))
			}
			state = state.setIn(['modalCreate', 'show'], false)
			state = state.setIn(['modalCreate', 'title'], '')
			state = state.setIn(['modalCreate', 'mode'], '')
			state = state.setIn(['modalCreate', 'data'], null)
			return state
		case types.DESHABILITAR_BOTON_MODAL_ADMIN_PARAMETROS:
			state = state.setIn(['modalCreate', 'btnDisabled'], action.payload)
			return state
		case types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_ADMIN_PARAMETRO:
			state = state.setIn(['modalDelete', 'show'], action.payload.open)
			state = state.setIn(['modalDelete', 'action'], action.payload.action)
			state = state.setIn(['modalDelete', 'message'], action.payload.message)
			return state
		case types.ELIMINAR_ADMIN_PARAMETRO:
			index = state.get('parametros').findIndex(x => x.get('id') === action.payload)
			state = state.deleteIn(['parametros', index])
			state = state.setIn(['modalDelete', 'show'], false)
			state = state.setIn(['modalDelete', 'action'], null)
			state = state.setIn(['modalDelete', 'message'], null)
			return state
		case types.ADICIONAR_NUEVA_CONFIGURACION_ADMIN_PARAMETRO:
			let newItem = Immutable.fromJS(parametroConfig())
			newItem = newItem.set('posicion', state.getIn(['modalCreate', 'data', 'parametro_cols']).count() + 1)
			state = state.updateIn(['modalCreate', 'data', 'parametro_cols'], list => list.push(Immutable.fromJS(newItem)))
			return state
		case types.ELIMINAR_CONFIGURACION_ADMIN_PARAMETRO:
			state = state.setIn(['modalCreate', 'data', 'parametro_cols'], state.getIn(['modalCreate', 'data', 'parametro_cols']).filter(x => !x.get('selected')).sortBy(x => x.get('posicion')).map((x, n) => x.set('posicion', n + 1)))
			return state
	    default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/parametros.js